(function () {'use strict';}());
angular.module('app').service('AppService', function($http)
{
	var trace = angular.trace;
	var lookup = {};
	var listing = [];
	var self = {};
	var device = (/android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));

	self.loadContent = function(){
		return $http.get("content/gpb.json").success(onLoadContent).error(onLoadError);
	};

	function onLoadContent(data){

		//store some high level content for quick access elsewhere in app
		self.minigames = data.content["mini-games"];
		self.adventures = data.content.global.content.adventures;
		self.adventureListing = [];
		self.artifacts = data.content.artifacts.artifacts;
		self.panels = device ? data.content.mpanels : data.content.panels;
		self.stages = data.content.stages;
		self.help = data.content.global.help;
		self.cutscenes = data.content.panels.cutscenes;
		self.audio = data.content.global.audio;
		if(device) delete data.content.panels;
		self.device = device;
		synthesize(data);

		trace("data synthesized",data,"---------");
	}
	function onLoadError(){
		trace("error loading content",arguments);
	}
	function synthesize(data){

		//unpack the concatenated json and replace object identifiers with actual references to data
		for(var name in self.adventures){
			var adventure = self.adventures[name];
			var locations = adventure.locations;
			adventure.id = name;
			self.adventureListing.push(adventure);

			for(var i = 0, count = locations.length; i < count; i++){
				var location = locations[i];
				var gameinfo = (/^(.*?):(.*?)$/gim).exec(location["mini-game"]);
				if(!location["mini-game"]) continue;


				var artifactID = location.artifact;
				location.artifact = self.artifacts[location.artifact];
				if(location.artifact) 
				{
					location.artifact.id = artifactID;
					location.artifact.period = getPeriodLabel(location.artifact);
				}
				location["mini-game"] = self.minigames[gameinfo[1]][gameinfo[2]];
				location["mini-game"].type = gameinfo[1];
				location["mini-game"].intro = "mini-"+gameinfo[1];//self.panels["mini-"+gameinfo[1]];
			}
		}

		self.adventureListing.sort(function(a,b){
			if(a.index > b.index) return 1;
			return -1;
		});

	}


	function getPeriodLabel(artifact){
		var array = artifact.periods[0].split(":");
		var adventure = array[0];
		var id = array[1];
		var listing = self.adventures[adventure].periods;

		for(var i = 0, count = listing.length; i < count; i++){
			if(listing[i].id === id) return listing[i].label;
		}
		return null;

	}

	return self;
});
